<div class="validation-page">
  <div class="validation-container">
    @if (crewInfo && validationMode) {
      <app-change-password
        [crew]="crewInfo"
        [mode]="validationMode"
        [standalone]="true"
        (validationComplete)="onValidationComplete($event)">
      </app-change-password>
    }
  </div>
</div>